import React, { useEffect, useState } from 'react';
import './RelatedProducts.css';
import Item from '../Item/Item';
import { backend_url } from '../../App';

const RelatedProducts = ({ category, subcategory, id }) => {
  const [related, setRelated] = useState([]);

  useEffect(() => {
    fetch(`${backend_url}/relatedproducts`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ category, subcategory }),
    })
      .then((res) => res.json())
      .then((data) => setRelated(data))
      .catch((err) => {
        console.error("Failed to load related products:", err);
        setRelated([]);
      });
  }, [category, subcategory]);

  const handleItemClick = () => {
    setTimeout(() => window.location.reload(), 10);
  };

  const filtered = related.filter((item) => id !== item.id);

  return (
    <div
      className="relative overflow-hidden px-4 sm:px-8 py-10"
      style={{ background: "linear-gradient(180deg, var(--brand-bg) 0%, var(--brand-surface) 100%)" }}
    >
      {/* Dot grid */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, var(--brand-primary-600) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center mb-8 gap-2">
          <span
            className="text-white text-xs font-bold px-4 py-1 rounded-full"
            style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
          >
            You May Also Like
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900 text-center"
            style={{ fontFamily: "'Times New Roman', Serif" }}
          >
            Related Products
          </h2>
          <div className="flex items-center gap-3">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[var(--brand-primary-400)]" />
            <div className="w-1.5 h-1.5 rotate-45 bg-[var(--brand-primary-500)]" />
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[var(--brand-primary-400)]" />
          </div>
        </div>

        {filtered.length === 0 ? (
          <p className="text-center text-gray-400 py-8">No related products found.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {filtered.map((item) => {
              const offerPrice = (item.old_price * (100 - item.new_price)) / 100;
              const discountPercentage = ((item.old_price - offerPrice) / item.old_price) * 100;
              return (
                <div
                  key={item.id}
                  onClick={handleItemClick}
                  className="group rounded-2xl overflow-hidden border-2 border-[var(--brand-primary-100)]
                             hover:shadow-[0_8px_28px_rgba(124,58,237,0.2)]
                             hover:border-[var(--brand-primary-300)] hover:-translate-y-1.5
                             transition-all duration-300 bg-white"
                >
                  <Item
                    id={item.id}
                    name={item.name}
                    image={item.images?.[0] || ""}
                    new_price={offerPrice.toFixed(2)}
                    old_price={item.old_price}
                    discountPercentage={discountPercentage.toFixed(0)}
                    scale={item.scale}
                    quantity={item.quantity}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedProducts;
